'use client';

import React from 'react';

import Image from 'next/image';

import foodImg from '@/assets/images/food-comp.png';
import { replaceLastPartOfUrl } from '@/helpers/utils/common';
import { FooterDetails } from '@/types/LeadGeneration';

import Container from '../../Container';
import { useImageData } from '../hooks/useImageData';

type FooterProps = {
  footerData?: FooterDetails;
};

const Footer = ({ footerData }: FooterProps) => {
  if (footerData?.image) {
    footerData.image.url = replaceLastPartOfUrl(footerData.image?.url, 'hd');
  }

  const { image: imageDesktop } = useImageData(footerData?.image, 497, 419);
  const { image: imageMobile } = useImageData(footerData?.imageMobile, 497, 419);

  return (
    <div className="v2-w-full">
      <div className="v2-bg-primary">
        <Container className="md:v2-px-[56px]">
          <div className="v2-grid v2-grid-cols-2 xs:v2-grid-cols-1 sm:v2-grid-cols-1 md:v2-grid-cols-2">
            <div className="">
              <Image
                alt="Food Image"
                src={foodImg}
                height={497}
                width={419}
                className="-v2-mt-[40px] sm:v2-mx-auto xs:v2-mx-auto"
              />
            </div>
            <div className="v2-pt-[65px] md:v2-pt-[65px] sm:v2-pt-[40px] xs:v2-pt-[40px] v2-pb-[42px]">
              <h2 className="v2-text-4xl md:v2-text-4xl xs:v2-text-3xl sm:v2-text-3xl v2-text-white v2-font-sweet-sans-pro v2-font-normal v2-mb-6">
                Welcome To The Proactive Pet Parent Movement!
              </h2>
              <p className="v2-text-lg md:v2-text-lg xs:v2-text-base sm:v2-text-base v2-font-sweet-sans-pro-light v2-font-light v2-text-white v2-mb-[73px] md:v2-mb-[73px] xs:v2-mb-[44px] sm:v2-mb-[44px]">
                Because what you do today affects your pet&apos;s health tomorrow and for years to come.
              </p>
              {/* <p className="v2-text-sm md:v2-text-sm xs:v2-text-xs sm:v2-text-xs v2-leading-[17px] md:v2-leading-[17px] xs:v2-leading-normal sm:v2-leading-normal v2-font-sweet-sans-pro-light v2-font-light v2-text-white">
                ©2024 pawTree, LLC. All Rights Reserved
              </p> */}
            </div>
          </div>
        </Container>
      </div>
      {/* <Image
        alt={imageDesktop.alt}
        src={imageDesktop.url}
        height={1000}
        width={1000}
        priority={true}
        layout="responsive"
        quality={100}
        className="-v2-mt-[40px] v2-max-w-full md:v2-block v2-hidden v2-mx-auto v2-w-full"
      />
      <Image
        alt={imageMobile.alt}
        src={imageMobile.url}
        height={1000}
        width={1000}
        priority={true}
        layout="responsive"
        quality={100}
        className="-v2-mt-[40px] v2-max-w-full sm:v2-block xs:v2-block md:v2-hidden v2-mx-auto v2-w-full"
      /> */}
    </div>
  );
};

/* <div className="v2-pt-[65px] v2-pb-[42px]">
            <h2 className="v2-text-4xl md:v2-text-4xl xs:v2-text-3xl sm:v2-text-3xl v2-text-white v2-font-sweet-sans-pro v2-font-normal v2-mb-6">
              {footerData?.Headline}
            </h2>
            <p className="v2-text-lg md:v2-text-lg xs:v2-text-base sm:v2-text-base v2-font-sweet-sans-pro-light v2-font-light v2-text-white v2-mb-[73px] md:v2-mb-[73px] xs:v2-mb-[44px] sm:v2-mb-[44px]">
              {footerData?.CopyText ?? ''}
            </p>
            <p className="v2-text-sm md:v2-text-sm xs:v2-text-xs sm:v2-text-xs v2-leading-[17px] md:v2-leading-[17px] xs:v2-leading-normal sm:v2-leading-normal v2-font-sweet-sans-pro-light v2-font-light v2-text-white">
              ©2024 pawTree, LLC. All Rights Reserved
            </p>
          </div> */

export default Footer;
